import React from 'react';
import { View, Text, StyleSheet, Platform } from 'react-native';

interface LoadingTableContainerProps {
  title: string;
  style?: any;
}

const LoadingTableContainer: React.FC<LoadingTableContainerProps> = ({ title, style }) => (
  <View style={[styles.tableLoaderContainer, style]}>
    <Text style={styles.tableLoadingText}>Loading {title}...</Text>
  </View>
);

const styles = StyleSheet.create({
  tableLoaderContainer: {
    marginTop: 20,
    padding: 40,
    backgroundColor: '#FFFFFF',
    borderRadius: 8,
    borderWidth: 1,
    borderColor: '#D7E5F8',
    justifyContent: 'center',
    alignItems: 'center',
    minHeight: 200,
  },
  tableLoadingText: {
    marginTop: 16,
    fontSize: 14,
    color: '#3A3A3A',
    fontFamily: Platform.select({
      ios: 'Inter',
      android: 'Inter-Regular',
      web: 'Inter, -apple-system, Roboto, Helvetica, sans-serif',
    }),
    textAlign: 'center',
  },
});

export default LoadingTableContainer;
